const formatTime = (time: number) => {
  const hours = Math.floor(time / 3600);
  const afterHours = time % 3600;
  const minutes = Math.floor(afterHours / 60);
  const seconds = Math.floor(afterHours % 60);
  const format: string[] = [];
  if (hours > 0) format.push(`${hours < 10 ? '0' : ''}${hours}h`);
  if (minutes > 0 || hours > 0)
    format.push(`${minutes < 10 ? '0' : ''}${minutes}m`);
  format.push(`${seconds < 10 ? '0' : ''}${seconds.toFixed(0)}s`);
  return format.join(', ');
};

export default formatTime;
